export default "/static/dashboard/build/app/img/v2/ab9d8f857d2f0a3da49efbebaa07ddf7.png";